<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>Remote Monitoring System</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <!-- <link href="assets/img/favicon.png" rel="icon">-->
  <link href="assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Raleway:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">
  <link href="http://fonts.cdnfonts.com/css/mulish" rel="stylesheet">

</head>

<body>

  <app-header></app-header>

  <section id="hero" class="hero_slide cust-hero-slider">
    <div data-bs-interval="5000" class="" data-bs-ride="carousel">

      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 mt-5 cust-slider-left-text pad_top_30">
            <h2 class="animate__animated animate__fadeInDown text-alignment-center">Level Monitoring <br
                class="text_hide"> System</h2>
            <p class="animate__animated animate__fadeInUp width-100 m-0 text-alignment-center">Moniter and Schedule
              filling or emptying of tanks.<br class="text_hide">
              Optimize supply-demand Trace leakages.<br class="text_hide">Remotely control pump/tank valves.
              <br class="text_hide"> Precdict future demand using data analytics.
            </p>

            <div class="flex_center pad-top-25">
              <a href="https://www.samyak.com/contact-us/"
                class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer text-alignment">Contact
                Us</a>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 text-right">
            <img src="../../assets/img/slide-2-1.svg" class="slider-img-level slider-img">
          </div>
        </div>


      </div>
    </div>
  </section>

  <main id="main">
    <section id="clients" class="clients">
      <div class="container p-0">
        <div class="row client-logo-main">
          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
          </div>

          <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
            <img src="../../assets/img/rech.svg" class="img-fluid" alt="">
          </div>

        </div>

      </div>
    </section>


    <section id="services" class="services">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4 pb-4">What are the challenges do manufacturer face?</p>

        </div>

        <div class="align-items-center text-center justify-content-center">
          <img src="assets/images/level_monitoring_gif_1.gif" alt="">
        </div>

      </div>
    </section>




    <section id="cta" class="cta space-comman">

      <div class="container aos-init aos-animate" data-aos="zoom-in">
        <div class="row display_two_column">
          <div class="first_column_image pb-3">
            <img src="assets/img/iot-chart.svg">
          </div>
          <div class="second_column_text">
            <div class="second_column_image">
              <h3 class="text-left">What are Level Monitoring Solutions?</h3>
              <p class="mt-30 text_jus"> With Level Monitoring solutions, you can remotely monitor liquid level inside
                the tank/reservoir in real-time. These solutions allow you to access the fluid level information,
                temperature, and RH on mobile phones as well as desktops.
              </p>
              <p class="mt-30 text_jus">
                Using these solutions, you will be able to manage inventory effectively. The real-time visibility aware
                you of the days left in existing stock and theft for multiple locations at a time</p>

            </div>
          </div>
        </div>
      </div>
    </section>






    <section id="Advanced Energy" class="services">
      <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row display_two_column-1">
          <div class="second_column_text">
            <div class="second_column_image">
              <div class="section-title Energy-Analytics-title">

                <p class="heading-left pad-top-desk">Brief overview of the system</p>

              </div>
              <ul class="overview list_item">
                <li>We offer end to end IIOT solution which come with everything from Electronics to web and mobile
                  application.</li>
                <li>From your industrial plant,bulidings and machinery,we send required data to cloud server using 4g
                  gsm modem or through wired cabel.</li>
                <li>Server can be any cloud or in-house.</li>
                <li>GSM modem supports communication protocols like wifi, ethernet or GSM.</li>
                <li>Custom Alrams,alert messages can be set.</li>
                <li>User defined custom reporting and custom dashboard can be created.</li>
              </ul>
            </div>
          </div>
          <div class="first_column_image pb-3">
            <div class="align-items-center text-center justify-content-center pad_27">

              <img class="embed-responsive-item" src="assets/img/level_moitoring_brief.svg">

            </div>
          </div>
        </div>
      </div>
    </section>






    <section id="How-Rms-Works" class="services gray-container space-comman padding-bottom-50 margin-bottom-0">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4">Level Monitoring Solutions Application Area</p>

        </div>

        <div class="row pad_15">

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
            <div class="icon-box height-435">
              <div class="icon-container pb-3"><img src="assets/img/watertank1.svg" class="icon_img_mobile"></div>
              <h4><a href="">Water Tank Level Monitoring</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">With merely a sensor mounted on the water tank,
                our solution gives you with real-time insights into your available water inside your tanks. Samyak's
                Remote Monitoring solution ensures that no problems arise, such as water spilling from overhanging water
                tanks. When your tank is about to run out of gas, you will be notified. Users can also adjust the
                threshold limitations with this solution.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/configuration.svg" class="icon_img_mobile"></div>
              <h4><a href="">Fuel/Oil Tank Level Monitoring</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">Samyak's Remote Monitoring System can be used
                to monitor mobile fuel tanks, gas stations, and diesel tanks remotely, allowing distributors and
                supervisors to know the real-time fuel stock level in their tanks. It saves time for your organization
                by providing precise gasoline dispensing. You'll be able to maximize your inventory levels this way.</p>
            </div>
          </div>


          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/waste.svg" class="icon_img_mobile"></div>
              <h4><a href="">Sewage Tank Monitoring</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">Sewage tanks can be monitored using the RMS
                IIoT Solution. When tanks reach a specific threshold, drivers are notified, and they proceed to the
                tanks to empty them into their trucks. This aids in minimizing tank overflow and maximizing resource
                utilization.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/weather.svg" class="icon_img_mobile"></div>
              <h4><a href="">Waste Water Treatment Plant</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">The RMS from Samyak aids in the control and
                monitoring of waste water treatment systems. All pump operating hours can be recorded and analyzed in
                the cloud. Pumps can also be turned on and off remotely from any location on the planet. Graphs can be
                used to see if something is out of the ordinary.</p>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/smart_irrigation.svg" class="icon_img_mobile"></div>
              <h4><a href="">Smart Irrigation</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">You will never run out of water for irrigation
                with the Samyak's RMS system. Your motors will never run out of water thanks to real-time insights into
                your water supplies. The concerned person will be notified if the water level falls below the set
                limits, and the motors will be turned off automatically.</p>
            </div>
          </div>


          <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
            <div class="icon-box height-435">
              <div class="icon-container"><img src="assets/img/reservoir.svg" class="icon_img_mobile"></div>
              <h4><a href="">Reservoir Level Monitoring</a></h4>
              <p class="text_jus" style="margin-bottom: 0px !important;">The RMS from Samyak keeps track of the
                reservoir and surface water levels.Reservoirs are subjected to a variety of environmental factors that
                cause water levels to rise and fall. Knowing the water levels in the reservoirs assures that you will
                have enough water in the future.Data analytics also aids in demand-supply optimization, which aids in
                the preservation of dried-up lakes throughout the summer.</p>

            </div>
          </div>

        </div>
      </div>
    </section>


    <section id="services" class="services">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4">Level Monitoring Benefits</p>

        </div>

        <div class="align-items-center text-center justify-content-center mt-30">
          <img src="assets/img/Leavel_moni.gif" class="img-fluid" alt="">
        </div>

      </div>
    </section>



    <section id="testimonials" class="testimonials section-bg services mt-30 ">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-4 pad_15">Custom Report and Dashboard for Level Monitoring</p>

        </div>

        <div class="best_service">
          <owl-carousel [options]="SlideOptions3" [carouselClasses]="['owl-theme', 'sliding']">
            <div class="item" *ngFor="let img of Images1">
              <div style="align-content: center">
                <div class="icon-box icon-box2 icon-box3">
                  <div class="icon-container"><img src="{{img.img}}"></div>
                  <h4><a class="font-weight-500" href="">{{img.title}}</a></h4>
                  <p>{{img.text}}<span></span></p>

                </div>
              </div>
            </div>
          </owl-carousel>
        </div>
      </div>
    </section>


    <section id="testimonials" class="industries testimonials section-bg services">
      <div class="container aos-init aos-animate" data-aos="fade-up">

        <div class="section-title">

          <p class="pt-3" style="color: #fff;">Industries We Serve</p>

        </div>

        <div class="best_service">
          <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
            <div class="item" *ngFor="let img of Images2">
              <div class="">
                <div class="icon-container34">
                  <p><img class="indus-img" src="{{img.img}}"></p>
                  <div class="h3">{{img.title}}</div>
                </div>
              </div>
            </div>
          </owl-carousel>
        </div>

      </div>
    </section>




    <section id="testimonial-area" class="pt-5 padding-bottom-new">

      <div class="container">
          <div class="mx-auto">
              <header class="section-header text-center">

                  <h2  class="m_top">What our Customers are Saying</h2>
              </header>
          </div>
          <div class="testimonial-block" style="padding-bottom: 40px; padding-top: 45px;">
              <div style="width: 428px;" class="image_display"><img src="assets/img/user5.svg" alt=""
                      class="testimonial_img"></div>

              <div class="padding-both-side">

                  <h1> <span><img src="../../assets/img/comma.svg" class="commam"></span></h1>
                  <p class="text_align_center" style="font-size: 14px;">“Samyak's support is really good and we are
                      very happy with the services they have provided to us like hardware data integration through GSM
                      gateways. Two way communication is helping us a big time. We heartily appreciate all kind of
                      support.”</p>
                  <div class="testimonial">
                      <p class="testimonialFrom text_align_center" style="font-size: 14px;">Jummal Popis</p>
                      <p class="text_align_center" style="font-size: 14px;">Founder Circle</p>
                  </div>
              </div>
          </div>



      </div>

  </section>

    <app-latest-article></app-latest-article>



  </main>

  <app-footer></app-footer>

  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>



  <!-- Testimonial js -->
  <script>
    System.import('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js')
    $(document).ready(function () {

      $('.client-single').on('click', function (event) {
        event.preventDefault();

        var active = $(this).hasClass('active');

        var parent = $(this).parents('.testi-wrap');

        if (!active) {
          var activeBlock = parent.find('.client-single.active');

          var currentPos = $(this).attr('data-position');

          var newPos = activeBlock.attr('data-position');

          activeBlock.removeClass('active').removeClass(newPos).addClass('inactive').addClass(currentPos);
          activeBlock.attr('data-position', currentPos);

          $(this).addClass('active').removeClass('inactive').removeClass(currentPos).addClass(newPos);
          $(this).attr('data-position', newPos);

        }
      });

    }(jQuery));

  </script>
  <script>

    var testimonialItems = document.querySelectorAll(".item label");
    var timer;
    function cycleTestimonials(index) {
      timer = setTimeout(function () {
        var evt;
        if (document.createEvent) {
          //If browser = IE, then polyfill
          evt = document.createEvent('MouseEvent');
          evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        } else {
          //If Browser = modern, then create new MouseEvent
          evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
            clientX: 20
          });
        }
        var ele = "." + testimonialItems[index].className;
        var ele2 = document.querySelector(ele)
        ele2.dispatchEvent(evt);
        index++; // Increment the index
        if (index >= testimonialItems.length) {
          index = 0; // Set it back to `0` when it reaches `3`
        }
        cycleTestimonials(index); // recursively call `cycleTestimonials()`
        document.querySelector(".testimonials").addEventListener("click", function () {
          clearTimeout(timer); //stop the carousel when someone clicks on the div
        });
      }, 3000); //adjust scroll speed in miliseconds
    }
    //run the function
    cycleTestimonials(0);
  </script>

</body>

</html>